// extracted by mini-css-extract-plugin
export default {"list":"Advantage_list__RaCVe","item":"Advantage_item__Kaakr","title":"Advantage_title__lj1Lk"};